import CardViewComponent from '../../../../../lib/CardViewComponent/CardViewComponent';

import {
  Modal,
  ModalContent,
  ModalContentText,
  ModalTitle,
} from '@deere/fuel-react';
import React from 'react';
import './ExistingMandateBankDetailsModal.css';
import {connect} from 'react-redux';

const ExistingMandateBankDetailsModal = (props) => {
  const handleClose = () => {
    props.setVisible(false);
  };

  return (
    <Modal
      className="EquipmentViewPopup"
      open={props.visible}
      onClose={handleClose}
      aria-labelledby="alert-Modal-title"
      aria-describedby="alert-Modal-description"
      fullWidth={true}
    >
      <ModalTitle bgcolor={'#F0F0F0'} id={'alert-Modal-title'}>
        {props.title}
      </ModalTitle>
      <ModalContent>
        <ModalContentText id="alert-Modal-description">
          <div className="existingMandateSection">
            {props.mandateData &&
              props.mandateData.length > 0 &&
              props.mandateData.map((asset, index) => (
                <CardViewComponent
                  key={'card-' + JSON.stringify(Object.keys(asset)[0])}
                  records={asset}
                />
              ))}
          </div>
        </ModalContentText>
      </ModalContent>
    </Modal>
  );
};

export const mapStateToProps = (state) => {
  return {
    contractDetails: state.appStates.contractDetails?.accountDetails,
    countryCode: state.appStates.allContracts?.countryCode,
  };
};
export default connect(mapStateToProps)(ExistingMandateBankDetailsModal);
